export enum EnvironmentTypes {
    Local = 0,
    Dev = 1,
    UAT = 2,
    Prod = 3
}
